// src/components/HomePage.js
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Layout from './Layout';
import ClientCarousel from './ClientCarousel';
import './HomePage.css';
import { auth } from '../firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

function HomePage() {
  const navigate = useNavigate();

  // Local auth gate to avoid banner flicker
  const [authReady, setAuthReady] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setLoggedIn(!!u);
      setAuthReady(true);
    });
    return () => unsub();
  }, []);

  const handleStartTrial = () => {
    if (loggedIn) navigate('/active-plan');
    else navigate('/login');
  };

  // Show trial banner only after auth state is known
  const showTrialBanner = authReady && !loggedIn;

  return (
    <Layout>
      <div className="home-page">
        <header className="hero-section">
          <img
            src={`${process.env.PUBLIC_URL}/images/tm logo cream background.png`}
            alt="Left Logo"
            className="logo-left"
          />
          <div className="text-content">
            <h1>Welcome to Tender Managers</h1>
            <p>Your go-to platform for tender management and insights.</p>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/images/tm logo cream background.png`}
            alt="Right Logo"
            className="logo-right"
          />
        </header>

        {showTrialBanner && (
          <section className="trial-banner" aria-live="polite">
            <p>
              <span className="new-pill">NEW</span>&nbsp;&nbsp;
              <strong>New here?</strong>&nbsp;Log in to unlock your <span>3-Day Free Trial</span> — full
              access to the <strong>Dashboard</strong> with live tenders, archive tenders, results of tenders from
              <strong> GeM</strong>, <strong> 37 State Govt.</strong> &amp; <strong> 99 Central Govt.</strong> Tender Portals
              plus access to GeM Procurement Reports (Direct Orders and Bids) and TenderMaker/Bid Studio.
            </p>
            <button className="cta" onClick={handleStartTrial}>Start Free Trial</button>
          </section>
        )}

        <section className="resources-section">
          <h2>Explore Our Resources</h2>
          <div className="resources-grid">
            <div className="resource-card">
              <h3>All Gem Categories</h3>
              <p>Browse comprehensive categories for tenders.</p>
              <Link to="/resources/gem-categories">Learn More</Link>
            </div>
            <div className="resource-card">
              <h3>Government Portals</h3>
              <p>Access government portals for tender opportunities.</p>
              <Link to="/resources/government-portals">Learn More</Link>
            </div>
            <div className="resource-card">
              <h3>Govt Departments</h3>
              <p>Explore central and state government departments.</p>
              <Link to="/resources/govt-orgs-and-depts">Learn More</Link>
            </div>
            <div className="resource-card">
              <h3>Procurement Rules</h3>
              <p>Discover consolidated procurement rules.</p>
              <Link to="/resources/procurement-rules">Learn More</Link>
            </div>
          </div>
        </section>

        <div className="carousel-section">
          <ClientCarousel />
        </div>

        <main className="content">
          <section className="company-description">
            <h2>What We Do</h2>
            <p>
              We provide comprehensive solutions for managing tenders, helping businesses
              streamline their processes and achieve better results. With our expertise,
              you can simplify your tender management and focus on what matters most.
            </p>
          </section>
          <section className="contact-us">
            <h2>Contact Us</h2>
            <p>Email: info@tendermanagers.com</p>
            <p>Phone: +91-8655654720</p>
          </section>
        </main>
      </div>
    </Layout>
  );
}

export default HomePage;
